import { useState, useEffect } from 'react'

import debounce from 'lodash/debounce'

import { Breakpoints, Orientation } from 'common/types'

const MOBILE_BREAKPOINT = Breakpoints.LG
const RESIZE_DEBOUNCE_WAIT = 300

const checkIsMobile = () => window.innerWidth < MOBILE_BREAKPOINT

const getOrientation = () => {
  return window.innerWidth <= window.innerHeight ? Orientation.PORTRAIT : Orientation.LANDSCAPE
}

const useLayout = () => {
  const [isMobile, setIsMobile] = useState(checkIsMobile())
  const [orientation, setOrientation] = useState(getOrientation())

  useEffect(() => {
    const debounceHandleResize = debounce(() => {
      setIsMobile(checkIsMobile())
      setOrientation(getOrientation())
    }, RESIZE_DEBOUNCE_WAIT)

    window.addEventListener('resize', debounceHandleResize)

    return () => {
      window.removeEventListener('resize', debounceHandleResize)
    }
  }, [])

  return {
    isMobile,
    isDesktop: !isMobile,
    orientation,
    isPortrait: orientation === Orientation.PORTRAIT,
    isLandscape: orientation === Orientation.LANDSCAPE
  }
}

export default useLayout
